import { Flow, onlyUnique } from "./Flow";


export class Group {
    name: string;
    flows: Flow[] = []
    envs: any[] = [];
    tRuns: number = 0;
    tFails: number = 0;
    tEstimates: number = 0;
    tActions: number = 0;
    connections: any[] = [];
    modified: Date = null;
    lastRun: Date = null;
    solution: any = null;

    environments: string = '';

    favicon: string = null;

    constructor(name: string, init?: any){
        this.name = name;
        if (init) {
            this.initialize(init);
        }
    }

    initialize(init: any) {

    }

    add(...flows:Flow[]){

        this.flows.push(...flows);

    }

    organize() {
        this.tRuns = this.flows.map( (flow:Flow)=> flow.runsCount).reduce((a, b)=>a + b, 0);
        this.tFails = this.flows.map( (flow:Flow)=> flow.runsFailCount).reduce((a, b)=>a + b, 0);
        this.tEstimates = this.flows.map( (flow:Flow)=> flow.runsEstimate).reduce((a, b)=>a + b, 0);
    
        this.envs = this.flows.map( (flow:Flow)=> flow['_environment'] ).filter(env=>env).filter(onlyUnique);

        this.environments = this.envs.map(env=>env.properties.displayName).join(', ');
    
        this.modified = this.flows.map( (flow:Flow)=> flow.modified).sort()[0];
        this.lastRun = this.flows.map( (flow:Flow)=> flow.lastRun).sort()[0];
    
        this.connections = [].concat.apply([], this.flows.filter(flow=>flow.connections).map( flow=> flow.connections));

        this.tActions = this.flows.map( (flow:Flow)=> flow.actionsCount).reduce((a, b)=>a + b, 0);
        //debugger

        if (this.solution && this.solution.publisherid && this.solution.publisherid.supportingwebsiteurl) {
            this.favicon = `https://www.google.com/s2/favicons?domain=${this.solution.publisherid.supportingwebsiteurl}`;
        }         

    }
    
}